<template>
  <div class="progress">
    <div class="play-pause">
      <button v-if=!audioPlaying @click="playPause(true)">
        <img src="/images/ui/ui_play.png" alt="Play">
      </button>
      <button v-else @click="playPause(false)">
        <img src="/images/ui/ui_pause.png" alt="Pause">
      </button>
    </div>

    <span class="time"><span v-show="audioLoaded">{{ secondsToMinutes(rangeVal) }}</span></span>
    <input v-show="durationReady" class="bar" type="range" v-model="rangeVal" v-on:change="sliderChange" min="0" v-bind:max="trackDuration"
           ref="rangeEl"/>
    <span class="time"><span class="time" v-show="durationReady">{{ trackDurationFormatted }}</span></span>

    <InfoPop v-if="isGate" v-bind:popText="interfacePopText" v-bind:isTopLeft="false" @button="interactedInfoPop"/>
  </div>
</template>

<script>
import {
  bus
} from "@/main";
import InfoPop from '@/components/InfoPop'

export default {
  name: "AudioPlayer",
  components: {
    InfoPop
  },
  props: {
    audioSrc: String,
  },
  data() {
    return {
      audioTrack: null,
      trackDuration: null,
      trackDurationFormatted: null,
      audioPlaying: false,
      audioLoaded: false,
      durationReady: false,
      rangeVal: null,
      justCreated: true,
      sliderUsed: false,
      isGate: false,
      interfacePopText: 'You can activate other objects after closing down the audio player.',
      disabledInfoPop: false
    }
  },
  methods: {

    playPause(toPlay) {

      if (this.justCreated) {
        this.audioTrack = new Audio()
        this.audioTrack.src = this.audioSrc
        this.justCreated = false
        this.establishListeners()
      }

      this.audioPlaying = toPlay
      if (toPlay) {
        this.audioTrack.play()
        //console.log("called with " + toPlay)
      } else {
        this.audioTrack.pause()
        //console.log("called with " + toPlay)
      }
    },

    establishListeners() {
      setTimeout(this.addListeners.bind(this), 500)
    },

    addListeners() {
      this.audioTrack.addEventListener('timeupdate', this.audioChange.bind(this), false)
      this.audioTrack.addEventListener('ended', this.trackEnded.bind(this), false)
      this.$refs.rangeEl.addEventListener('click', this.sliderActive.bind(this), false)
      this.trackDurationFormatted = this.secondsToMinutes(this.audioTrack.duration)
      this.trackDuration = this.audioTrack.duration
      this.audioLoaded = true
      setTimeout(this.validateDuration.bind(this), 150)

    },
    validateDuration() {
      if (this.trackDurationFormatted == "NaN:aN" || this.trackDurationFormatted == "0:00") {
        this.trackDurationFormatted = this.secondsToMinutes(this.audioTrack.duration)
        setTimeout(this.validateDuration.bind(this), 150)
      } else {
        this.durationReady = true
      }

    },

    audioChange() {
      this.rangeVal = this.audioTrack.currentTime
    },

    sliderChange() {
      this.rangeVal = this.$refs.rangeEl.value
      this.audioTrack.currentTime = this.rangeVal
    },

    trackEnded() {
      this.rangeVal = 0
      this.audioPlaying = false
    },

    secondsToMinutes(seconds) {
      if (seconds == null) return;
      try {
        //let secondsConverted = Number(seconds.toFixed(0))
        let secondsConverted = Math.round(seconds * 100) / 100
        return Math.floor(secondsConverted / 60) + ':' + ('0' + Math.floor(secondsConverted % 60)).slice(-2);
      } catch (err) {
        return "0:00"
      }
    },

    sliderActive() {
      if (this.sliderUsed) return;
      this.sliderUsed = true
      bus.$emit("sliderOff", false)

      setTimeout(() => {
        bus.$emit("sliderOff", true)
        this.sliderUsed = false
      }, 1500)

    },
    interactedInfoPop() {
      this.$store.dispatch("audioInfoPopped", true);

    },


  },
  mounted() {
    bus.$on('playAudio', this.playPause);
    if (this.$route.name === 'Blue' || this.$route.name === 'Green' || this.$route.name === 'Yellow') {
      if (!this.$store.getters.audioInfoPopped) {
        this.isGate = true
      }
    } else {
      this.isGate = false

    }
  },

  beforeDestroy() {
    bus.$off('playAudio')
    this.playPause(false)

  },

  created() {
    this.rangeVal = 0
  },

}
</script>

<style scoped>
.progress {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  pointer-events: auto;
}

.play-pause {
  padding-right: .3em;
}

.play-pause button {
  width: 2em;
  font: inherit;
  background: none;
  color: inherit;
  border: none;
  padding: 0.4em 0;
  cursor: pointer;
  outline: inherit;
}

.play-pause img {
  padding: 0;
  margin: 0 auto;
  width: 45px;
  height: 45px;
  display: block;
}

.time {
  padding: 0;
  font-size: .65em;
  min-width: 2em;
}

.time:first-of-type span::after {
  content: '/';
}

input {
  display: none;
}

@media screen and (min-width: 660px) {
  .time {
    padding: 0 .75em;
    font-size: 1em;
    width: 4em;
    text-align: center;
  }

  .time:first-of-type span::after {
    content: none;
  }

  /* SLIDER STYLES */
  input {
    display: block;
    background-color: var(--modal-back);
    width: 100%;
  }

  /* DOT */
  /* Special styling for WebKit/Blink */
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid var(--darkest);
    height: 1em;
    width: 1em;
    border-radius: 50%;
    background: var(--darkest);
    cursor: pointer;
    margin-top: -.2em;
    /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    box-shadow: 1px 1px 1px var(--darkest), 0px 0px 1px var(--darkest);
    /* Add cool effects to your sliders! */
  }

  /* All the same stuff for Firefox */
  input[type=range]::-moz-range-thumb {
    box-shadow: 1px 1px 1px var(--darkest), 0px 0px 1px var(--darkest);
    border: 1px solid var(--darkest);
    height: 1em;
    width: 1em;
    border-radius: 50%;
    background: var(--darkest);
    cursor: pointer;
  }

  /* All the same stuff for IE */
  input[type=range]::-ms-thumb {
    box-shadow: 1px 1px 1px var(--darkest), 0px 0px 1px var(--darkest);
    border: 1px solid var(--darkest);
    height: 1em;
    width: 1em;
    border-radius: 50%;
    background: var(--darkest);
    cursor: pointer;
  }

  /* TRACK */
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 8.4px;
    cursor: pointer;
    background: rgb(170, 170, 170);
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background: rgb(170, 170, 170);
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 8.4px;
    cursor: pointer;
    background: rgb(170, 170, 170);
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 8.4px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  input[type=range]::-ms-fill-lower {
    background: rgb(170, 170, 170);
  }

  input[type=range]:focus::-ms-fill-lower {
    background: rgb(170, 170, 170);
  }

  input[type=range]::-ms-fill-upper {
    background: rgb(170, 170, 170);
  }

  input[type=range]:focus::-ms-fill-upper {
    background: rgb(170, 170, 170);
  }

  /* SLIDER END */
  @media screen and (min-width: 660px) {

  }
}
</style>
